const PEN_MARK = 'S/ ';

function unsignedParts(value) {
    const source = value === null || value === undefined ? '0' : String(value).trim();
    let normalized = source;
    if (source.includes(',')) {
        normalized = source.includes('.') && source.lastIndexOf(',') > source.lastIndexOf('.')
            ? source.replace(/\./g, '').replace(',', '.')
            : source.includes('.') ? source.replace(/,/g, '') : source.replace(',', '.');
    }
    const match = normalized.match(/^(-?)(\d+)(?:\.(\d+))?$/);

    if (!match) return { negative: false, integer: '0', fraction: '' };

    return {
        negative: match[1] === '-',
        integer: match[2].replace(/^0+(?=\d)/, '') || '0',
        fraction: match[3] || ''
    };
}

function addUnsigned(left, right) {
    const first = String(left).split('').reverse();
    const second = String(right).split('').reverse();
    const length = Math.max(first.length, second.length);
    const result = [];
    let carry = 0;

    for (let index = 0; index < length; index += 1) {
        const sum = Number(first[index] || 0) + Number(second[index] || 0) + carry;
        result.push(sum % 10);
        carry = Math.floor(sum / 10);
    }
    if (carry) result.push(carry);
    return result.reverse().join('').replace(/^0+(?=\d)/, '') || '0';
}

function roundedPenParts(value) {
    const parts = unsignedParts(value);
    let cents = parts.integer + (parts.fraction + '00').slice(0, 2);

    if (parts.fraction.length > 2 && Number(parts.fraction.charAt(2)) >= 5) {
        cents = addUnsigned(cents, '1');
    }
    cents = cents.replace(/^0+(?=\d)/, '') || '0';
    cents = cents.padStart(3, '0');

    return {
        negative: parts.negative && cents !== '000',
        integer: cents.slice(0, -2).replace(/^0+(?=\d)/, '') || '0',
        fraction: cents.slice(-2)
    };
}

function penMinor(value) {
    const parts = roundedPenParts(value);
    return parts.integer + parts.fraction;
}

function penFromMinor(value) {
    const normalized = String(value).replace(/^0+(?=\d)/, '') || '0';
    const cents = normalized.padStart(3, '0');
    return (cents.slice(0, -2).replace(/^0+(?=\d)/, '') || '0') + '.' + cents.slice(-2);
}

function multiplyUnsigned(value, quantity) {
    const multiplicand = String(value).split('').reverse();
    const multiplier = String(quantity).replace(/\D/g, '').split('').reverse();
    let total = '0';

    multiplier.forEach((digit, multiplierIndex) => {
        let carry = 0;
        const partial = [];
        multiplicand.forEach((current) => {
            const product = Number(current) * Number(digit) + carry;
            partial.push(product % 10);
            carry = Math.floor(product / 10);
        });
        if (carry) partial.push(carry);
        total = addUnsigned(total, partial.reverse().join('') + '0'.repeat(multiplierIndex));
    });
    return total;
}

export function formatPen(value) {
    const parts = roundedPenParts(value);
    const grouped = parts.integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (parts.negative ? '-' : '') + PEN_MARK + grouped + ',' + parts.fraction;
}

export function formatCrypto(value, mark) {
    const parts = unsignedParts(value);
    const fraction = parts.fraction.slice(0, 8).replace(/0+$/, '');
    const amount = (parts.negative && (parts.integer !== '0' || fraction) ? '-' : '')
        + parts.integer + (fraction ? '.' + fraction : '');
    return mark ? amount + ' ' + String(mark).trim() : amount;
}

export function addPen(left, right) {
    return penFromMinor(addUnsigned(penMinor(left), penMinor(right)));
}

export function multiplyPen(value, quantity) {
    return penFromMinor(multiplyUnsigned(penMinor(value), quantity));
}

export { PEN_MARK };
